module.exports = {
    analytics: {
        useDtm: true,
        useGtm: true,
        useTealium: false,
        tealiumAccount: 'woolworths',
        tealiumProfile: 'supermarkets',
        tealiumEnvironment: 'dev',
        tealiumNotAvailableValue: '',
        /* page type exceptions array contains pages with pre-defined types
        * if the page is not in this list it will be identified as 'other' page type
        */
        tealiumPageTypeExceptions: [
            'root',
            'shop.page',
            'shop.catalogue',
            'shop.browse',
            'shop.productdetails',
            'shop.recipes',
            'shop.recipedetail',
            'shop.search',
            'shop.locator',
            'shop.tripplanner',
            'shop.cart',
            'shop.list',
            'checkout',
            'hyf',
            'shop.confirmation',
            'shop.myaccount',
            'shop.inspiration',
            'shop.new',
            'shop.offergroup',
            'shop.productgroup',
            'shop.guestList',
            'shop.suggestedlists',
            'shop.authentication',
        ],
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/analytics.js